<template lang='pug'>
  div
    //- PopupPanelParking(:datosFinal='datosFinal')
    transition(name='slide-fade-down' appear mode='out-in')
      ods-tabs(v-model='tabsVertical' @tab-click="handleClick")
        ods-tab-pane(v-for='(item, index) in dataTabsMobility' :name="item.name" :label='$t(item.label)' :key='index')
      //  transition(name='fade')
            PopupBus(v-if='opened' :datosFinal='datosPopupBus')
    transition(name='slide-fade-down' mode='out-in' appear)
      MapToolsGeneric(ref='toolsGeneric' @updateFilter='updateFilter' verticalType="mobility")
    transition(name='fade')
      LegendMap(:verticalType='tabsVertical' :dataLengend='listMobility[tabsVertical].legend' :datosFinal='dataParkingPanels2' :dataParkingCurrent='dataParkingCurrent' ref="legendMap")
    transition(name='fadeSlide' appear)
      PanelDashboard(ref="panelDashboard")
        VerticalGeneric(
          slot="container"
          ref='verticalGeneric'
          @updateKpiGeneric='updateKpiGeneric'
          verticalType='mobility'
          @setPopupBusLine='setPopupBusLine'
          @setPopupParking='setPopupParking')
        MapZoomParks.panel-dashboard__tools.panel-dashboard__tools--bottom-left-out(
          slot="tools"
          ref='mapZoom')
        SearchMap.panel-dashboard__search.panel-dashboard__search--top-left-out(
          slot="search"
          ref="mapSearch"
        )
</template>

<script>
import MapZoomParks from '@/components/MapZoomParks'
import PanelDashboard from '@/components/PanelDashboard'
import MapToolsGeneric from '@/components/MapToolsGeneric'
import VerticalGeneric from '@/views/VerticalGeneric'
import PopupPanelParking from '@/components/PopupPanelParking'
import PopupBus from '@/components/PopupBus'
import LegendMap from '@/components/LegendMap'
import SearchMap from '@/components/SearchMap'

import axios from 'axios'

import jsonGisSensorZone from '@/moks/las_palmas/mobility/gisSensorZone'
import jsonGisParking from '@/moks/las_palmas/mobility/gisParking'
import jsonGisPanelParking from '@/moks/las_palmas/mobility/gisPanelParking'
import jsonGisBusLine from '@/moks/las_palmas/mobility/gisBusLine'
import jsonGisBusStop from '@/moks/las_palmas/mobility/gisBusStop'
import jsonGisBusRealTime from '@/moks/las_palmas/mobility/gisBusRealTime'
import jsonGisBike from '@/moks/las_palmas/mobility/gisBike'
// import PopupPanelParking from '@/components/LegendMap'
// import SockJS from 'sockjs-client'
// import Stomp from 'webstomp-client'

export default {
  name: 'MobilityAndTransportMain',
  data () {
    return {
      realTime: null,
      tabsVertical: '',
      mapLoad: false,
      /**  Data para las respuestas de los servicios de parking */
      contServiceParking: 0,
      contServiceAutobuses: 0,
      contServiceBike: 0,
      dataParkingSensorZones: [],
      dataParkings: [],
      datosFinal: [],
      dataParkingPanels: [],
      dataParkingPanels2: {},
      dataParkingCurrent: {},
      dataBike: [],
      datosPopupBus: [],
      opened: false,
      openedParking: false,
      openedPanel: false,
      openedZones: false,
      datosLegend: [],
      datosPopupBusLine: [],
      datosPopupParking: [],
      height: undefined,
      age: undefined,
      /** Pestañas con los subverticales de Movilidad. */
      listMobility: {
        Parking: {
          name: 'Parking',
          value: 'Parking',
          label: 'Parking',
          breadcumb: 'Aparcamientos',
          listCategory: [
            {
              value: 'dataSourceSensorZones',
              label: 'sensorZones',
              show: true
            },
            {
              value: 'dataSourceParking',
              label: 'parking',
              show: true
            },
            {
              value: 'dataSourcePanelParking',
              label: 'panelParking',
              show: true
            }
          ],
          listCategorySelected: ['dataSourceSensorZones', 'dataSourceParking', 'dataSourcePanelParking'],
          legend: [
            {
              label: 'Aparcamiento',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_parking_blue.svg',
              type: 'point'
            },
            {
              label: 'Panel de aparcamientos',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_parkingPanel_green.svg',
              type: 'point'
            },
            {
              label: 'Zonas de sensores',
              type: 'line',
              list: []
            }
          ]
        },
        Autobuses: {
          name: 'Autobuses',
          value: 'Autobuses',
          label: 'Autobuses',
          breadcumb: 'Autobuses',
          listCategory: [
            {
              value: 'dataSourceBusRealTime',
              label: 'busRealTime',
              show: true
            },
            {
              value: 'dataSourceBusLine',
              label: 'busLine',
              show: true
            }, {
              value: 'dataSourceBusStop',
              label: 'busStop',
              show: true
            }
          ],
          listCategorySelected: ['dataSourceBusRealTime', 'dataSourceBusLine', 'dataSourceBusStop'],
          legend: [
            {
              label: 'Autobuses',
              type: 'point'
            },
            {
              label: 'Paradas de autobus',
              type: 'point'
            },
            {
              label: 'Linea de autobus'
            }
          ]
        },
        Bike: {
          name: 'Bike',
          value: 'Bike',
          label: 'Bike',
          breadcumb: 'Bike',
          listCategorySelected: ['dataSourceBike'],
          listCategory: [
            {
              value: 'dataSourceBike',
              label: 'bike',
              show: true
            }
          ],
          legend: [
            {
              label: 'Bicicletas',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_bike_violet.svg',
              type: 'point'
            }
          ]
        }
      },
      dataTabsMobility: [
        {
          name: 'Autobuses',
          value: 'Autobuses',
          label: 'Autobuses',
          breadcumb: 'Autobuses'
        },
        {
          name: 'Parking',
          value: 'Parking',
          label: 'Parking',
          breadcumb: 'Aparcamientos'
        },
        {
          name: 'Bike',
          value: 'Bike',
          label: 'Bike',
          breadcumb: 'Bicicletas'
        }
      ]
      // received_messages: [],
    }
  },
  methods: {
    updatePopup (data) {
      this.datosFinal = data
      // this.opened = true
    },
    controlParkingService () {
    },
    controlAutobusesService () {
    },
    controlBikeService () {
    },
    setMapLoad () {
      this.mapLoad = true
      // this.$refs.mapSearch.changeBasemap()
    },
    changeCategory (category) {
      this.$emit('changeCategory', category)
    },
    changeSelectedKpi (val) {
      this.$emit('changeSelectedKpi', val)
      this.$refs.park.updateControlSelected(val)
    },
    getStation (val) {
      this.$emit('getStation', val)
    },
    handleClick (tab, event) {
      // this.$router.push({ name: this.tabsMobility + 'Dashboard' })
      // this.controlPage()
      // Descomentar cuando necesitemos PopupPanelParking
      // if (document.getElementById('cesiumPopupPanelParking')) {
      //   document.getElementById('cesiumPopupPanelParking').style.display = 'none'
      // }
      this.$refs.legendMap.open = false
      this.$refs.legendMap.data = false
      this.init()
      // this.$refs.verticalGeneric.updateSelectedStation()
      document.getElementById('dataIframe').contentWindow.resetEntityCards()
    },
    updateFilter (category, categorySelected) {
      this.$refs.verticalGeneric.updateKpis(category, this.tabsVertical)
    },
    cleanAndLoadDataGis () {
      const component = this
      var category = []
      var categorySelected = []
      var myLoadMap = () => {
        if (component.mapLoad === true && component.$refs.toolsGeneric !== undefined) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          category = component.listMobility[component.tabsVertical].listCategory
          categorySelected = component.listMobility[component.tabsVertical].listCategorySelected
          component.$refs.toolsGeneric.setToolsGeneric(
            category,
            categorySelected
          )
          component.loadDataFilter()
          component.$refs.verticalGeneric.updateKpis(categorySelected, component.tabsVertical)
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    loadDataFilter () {
      document.getElementById('dataIframe').contentWindow.activarDesactivarCapa(this.listMobility[this.tabsVertical].listCategory)
    },
    controlCollapsePanel (open) {
      this.$refs.panelDashboard.collapsePanel(open)
    },
    controlPage () {
      const component = this
      this.$refs.toolsGeneric.clearFilter()
      /*
      switch (this.$route.name) {
        case 'AutobusesDashboard':
          this.updateBusRealTime(true)
          this.tabsMobility = 'Autobuses'
          break
        case 'ParkingDashboard':
          this.updateBusRealTime(false)
          this.tabsMobility = 'Parking'
          break
        case 'BikeDashboard':
          this.updateBusRealTime(false)
          this.tabsMobility = 'Bike'
          break
      }
      */
      component.cleanAndLoadDataGis()
    },
    myTimerBike () {
      const component = this
      let simb = 'img/icon_bike_violet.svg'
      let simbSelect = 'img/icon_bike_white.svg'
      let simbIsolated = 'ods-icon-icon_bike_isolated'
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          component.dataBike,
          'mobilityBike',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelect,
          simbIsolated,
          0.8
        )
    },
    myTimerBusStop () {
      const component = this
      let simb = 'img/icon_busStop.svg'
      let simbSelect = 'img/icon_busStop_selected.svg'
      let simbIsolated = 'ods-icon-icon_busStop_isolated'
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          component.dataBusStop,
          'mobilityBus',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelect,
          simbIsolated,
          0.2
        )
    },
    myTimerBusLine  () {
      const component = this
      // let simb = 'img/icon_busStop_blue.svg'
      // let simbSelect = 'img/icon_busStop_white.svg'
      let simbIsolated = 'ods-icon-icon_route_isolated'
      // component.dataBusLine.properties.colorHex = '#FF00FF'
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          component.dataBusLine,
          'mobilityBus',
          'line',
          'entity',
          'field',
          1,
          'properties.colorHex',
          simbIsolated,
          0.8
        )
    },
    myTimerBus (valor) {
      // const component = this
      for (var i = 0; i < valor.length; i++) {
        const simb = 'img/icon_number_' + i + '.svg'
        const simbSelect = 'img/icon_number_' + i + '_selected.svg'
        const simbIsolated = 'ods-icon-icon_busStop_isolated'
        // llamada al icono del bus
        document.getElementById('dataIframe').contentWindow.createLayer(
          valor[i],
          'mobilityBus',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelect,
          simbIsolated,
          0.5)
      }
    },
    myTimerBusRealTime () {
      const component = this
      document
        .getElementById('dataIframe')
        .contentWindow.updateLayer(component.dataBusRealTime, 'dataSourceBusRealTime')
    },
    updateKpiGeneric () {
      const component = this
      // var category, categorySelected
      let categorySelected
      // category = component.$refs.toolsGeneric.getDataCategory()
      categorySelected = component.$refs.toolsGeneric.getCaterogySelected()
      component.$refs.verticalGeneric.updateKpis(categorySelected, this.tabsVertical)
    },
    updateBusRealTime (param) {
      const component = this
      if (param) {
        this.realTime = setInterval(function () {
          component.$store.dispatch('getBusRealTimeData')
        }, 5000)
      } else {
        clearInterval(this.realTime)
      }
    },
    setPopupBusLine (val, data) {
      this.datosPopupBusLine = []
      this.opened = val
      this.datosPopupBusLine = data
      let patron = /0+/
      let separado = this.datosPopupBusLine.name.split('_', 2)
      var linea = separado[0].replace(patron, '')
      this.datosPopupBusLine.nameLine = linea
    },
    setPopupParking (val, data, type, currentKpi) {
      this.$refs.legendMap.open = this.$refs.legendMap.data = true
      this.openedParking = val
      this.dataParkingPanels = []
      this.dataParkingPanels = data
      this.dataParkingPanels2 = data
      this.dataParkingCurrent = currentKpi
    },
    // connectWS () {
    //   const component = this
    //   this.socket = new SockJS(process.env.SERVICES_PROVIDER + '/ws')
    //   this.stompClient = Stomp.over(this.socket)
    //   this.stompClient.connect({}, (frame) => {
    //     this.stompClient.subscribe('/topic/public', (tick) => {
    //       var data = JSON.parse(tick.body)
    //       data.date = data.timestamp
    //       component.received_messages.push(data)
    //       console.log('Conectado')
    //       // if (component.received_messages.length > 0) {
    //       //   component.isHidden = false
    //       // }
    //     })
    //   }, (error) => {
    //     console.log(error)
    //     console.log('Reconectando')
    //     this.connectWS()
    //   })
    // }
    createLayerGIs (category, val) {
      const vm = this
      let simb = ''
      let simbSelect = ''
      let simbIsolated = ''
      switch (category) {
        case 'bike':
          simb = 'img/icon_bike_violet.svg'
          simbSelect = 'img/icon_bike_white.svg'
          simbIsolated = 'ods-icon-icon_bike_isolated'
          this.dataBike = val
          this.dataBike.name = 'Bike'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              this.dataBike,
              'mobilityBike',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8
            )
          break
        case 'sensorZones':
          this.dataParkingSensorZones = val
          this.dataParkingSensorZones.name = 'SensorZones'
          simbIsolated = 'ods-icon-icon_parking_zone_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              vm.dataParkingSensorZones,
              'mobilityParking',
              'polygon',
              'entity',
              'random',
              simbIsolated,
              0.99)
          break
        case 'parking':
          vm.dataParkings = val
          vm.dataParkings.name = 'Parking'
          simb = 'img/icon_parking_blue.svg'
          simbSelect = 'img/icon_parking_white.svg'
          simbIsolated = 'ods-icon-icon_parking_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              vm.dataParkings,
              'mobilityParking',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8
            )
          break
        case 'panelParking':
          this.dataParkingPanels = val
          this.dataParkingPanels2 = val
          this.dataParkingPanels.name = 'PanelParking'
          simb = 'img/icon_parkingPanel_green.svg'
          simbSelect = 'img/icon_parkingPanel_white.svg'
          simbIsolated = 'ods-icon-icon_parkingPanel_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              vm.dataParkingPanels,
              'mobilityParking',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8
            )
          break
        case 'busLine':
          simbIsolated = 'ods-icon-icon_route_isolated'
          this.dataBusLine = val
          this.dataBusLine.name = 'BusLine'
          // component.dataBusLine.properties.colorHex = '#FF00FF'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              this.dataBusLine,
              'mobilityBus',
              'line',
              'entity',
              'field',
              1,
              'properties.colorHex',
              simbIsolated,
              0.8
            )
          break
        case 'busStop':
          this.dataBusStop = val
          this.dataBusStop.name = 'BusStop'
          simb = 'img/icon_busStop.svg'
          simbSelect = 'img/icon_busStop_selected.svg'
          simbIsolated = 'ods-icon-icon_busStop_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              this.dataBusStop,
              'mobilityBus',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.2
            )
          break
        case 'busRealTime':
          this.dataBusRealTime = val
          this.dataBusRealTime.name = 'BusRealTime'
          let allBus = []
          for (let i = 0; i < val.features.length; i++) {
            var bus = []
            bus.features = []
            bus.name = 'BusRealTime'
            bus.type = 'FeatureCollection'
            bus.features[0] = val.features[i]
            allBus.push(bus)
          }
          if (allBus.length > 0) {
            for (let i = 0; i < allBus.length; i++) {
              simb = 'img/icon_number_' + i + '.svg'
              simbSelect = 'img/icon_number_' + i + '_selected.svg'
              simbIsolated = 'ods-icon-icon_busStop_isolated'
              // llamada al icono del bus
              document.getElementById('dataIframe').contentWindow.createLayer(
                allBus[i],
                'mobilityBus',
                'point',
                'entity',
                'billboard',
                simb,
                simbSelect,
                simbIsolated,
                0.5)
            }
          }
          break
      }
    },
    getMobilityGisData (category) {
      const vm = this
      return new Promise(function (resolve, reject) {
        axios({
          method: 'GET',
          url: process.env.SERVICES_PROVIDER + '/api/dashboard/environmentGis',
          headers: {
            Accept: 'application/json',
            Authorization: `${sessionStorage.getItem('sessionToken')}`
          },
          params: {
            type: category,
            country: 'ES',
            region: 'ES-GC',
            city: 'ES LPA'
          }
        }).then((response) => {
          vm.createLayerGIs(category, response.data)
          resolve({ value: true })
        }).catch((error) => {
          console.error(error)
          resolve({ value: false })
        })
      })
    },
    init () {
      const vm = this
      var myLoadMap = () => {
        let encontrado = false
        if (vm.mapLoad === true) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          let selectArray = vm.listMobility[vm.tabsVertical].listCategory
          selectArray.forEach(elem => {
            // 'dataSourceSensorZones', 'dataSourceParking', 'dataSourcePanelParking'
            document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
              .filter((data) => data._name.name === elem.value)
              .map((valor) => {
                valor.show = true
                encontrado = true
                return valor
              })
          })
          if (!encontrado) {
            vm.createLayerGIs('sensorZones', jsonGisSensorZone)
            vm.createLayerGIs('parking', jsonGisParking)
            vm.createLayerGIs('panelParking', jsonGisPanelParking)
            vm.createLayerGIs('busStop', jsonGisBusStop)
            vm.createLayerGIs('busLine', jsonGisBusLine)
            vm.createLayerGIs('busRealTime', jsonGisBusRealTime)
            vm.createLayerGIs('bike', jsonGisBike)
          }
          vm.controlPage()
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    }
  },
  created () {
    this.tabsVertical = this.listMobility.Parking.name
  },
  mounted () {
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    this.updateBusRealTime(false)
    next()
  },
  beforeDestroy () {
    document.getElementById('dataIframe').contentWindow.mapClear()
  },
  components: {
    MapZoomParks,
    PanelDashboard,
    MapToolsGeneric,
    VerticalGeneric,
    PopupPanelParking,
    PopupBus,
    LegendMap,
    SearchMap
  }
}
</script>

<style lang='scss' scoped>

/deep/ .ods-tabs {
  &__nav-wrap.is-scrollable {
    padding: 0 rem(48);
    width: 88%;
  }
  &__header {
    box-sizing: border-box;
    background: $--color-white;
    margin-bottom: 0;
    min-height: rem(64);
    padding: rem(12) rem(32);
    z-index: 2;
  }
  &__item {
    padding: rem(16) rem(24);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MobilityAndTransportMain.vue